// Icelandic. Same keys as nb in ../i18n.ts (the type checks that).
// The singular ("one") is also used for 21, 31, 41, ... (see PLURAL_ONE),
// so it says {n}, never a literal 1.
import type { Key, Text } from '../i18n.ts';

export const is: Record<Key, Text> = {
  appName: 'Finna tíma',
  tagline: 'finndu daginn sem hentar flestum',
  privacy: 'Persónuvernd',
  sourceCode: 'Frumkóði',
  heroTitle: 'Finndu tímann sem hentar flestum',
  heroLead: 'Búðu til viðburð, veldu mögulega daga eða tíma og deildu hlekknum. Allir merkja hvenær þeir geta – án innskráningar.',
  newEvent: 'Nýr viðburður',
  yourEvents: 'Viðburðirnir þínir',
  yourEventsHint: 'Aðeins munað á þessu tæki. Hlekkirnir virka á öllum tækjum.',
  showAllEvents: 'Sýna alla ({n})',
  findLink: 'Finndu viðburðina þína úr öðru tæki',
  findTitle: 'Finndu viðburðina þína',
  findLead: 'Sláðu inn netfangið sem þú gafst upp þegar þú bjóst til eða svaraðir viðburði. Við sendum kóða á það og svo bætast viðburðirnir við á þessu tæki.',
  findEmail: 'Netfang',
  findSend: 'Senda kóða',
  findSent: 'Ef netfangið hefur verið notað á viðburði hér kemur tölvupóstur með kóða innan skamms. Kóðinn gildir í 10 mínútur.',
  findCode: 'Kóði úr tölvupóstinum',
  findShow: 'Sýna viðburðina mína',
  findLinkLead: 'Smelltu á hnappinn til að bæta viðburðum netfangsins þíns við þetta tæki. Hlekkurinn virkar einu sinni.',
  findAgain: 'Senda nýjan kóða',
  findOther: 'Nota annað netfang',
  findAsked: 'Bað um nýjan kóða.',
  findFound: { one: 'Fann {n} viðburð. Honum hefur verið bætt við á þessu tæki.', other: 'Fann {n} viðburði. Þeim hefur verið bætt við á þessu tæki.' },
  findNone: 'Engir viðburðir fundust með þessu netfangi.',
  openAdmin: 'Stjórna',
  openMine: 'Svörin mín',
  open: 'Opna',
  tagAdmin: 'Stjórnandi',
  tagAnswered: 'Svarað',
  forget: 'Gleyma á þessu tæki',
  leave: 'Skrá út',
  leaveQ: 'Skrá út á þessu tæki?',
  leaveTextAdmin: 'Stjórnandahlekkurinn er fjarlægður af þessu tæki og viðburðurinn hverfur af listanum þínum hér. Þú þarft hlekkinn til að komast aftur, svo geymdu hann fyrst.',
  leaveTextMine: 'Persónulegi hlekkurinn þinn er fjarlægður af þessu tæki og viðburðurinn hverfur af listanum þínum hér. Þú þarft hlekkinn til að breyta svörunum síðar, svo geymdu hann fyrst.',
  leaveEmail: 'Þú getur líka fengið hlekkinn aftur með kóða í netfangið þitt.',
  leftToast: 'Útskráning á þessu tæki lokið',
  step1: 'Veldu mögulega daga',
  step1Text: 'Dagsetningar, eða tíma á hverjum degi. Fjarlægðu helgar og frídaga með einum smelli.',
  step2: 'Deildu hlekknum',
  step2Text: 'Einn hlekkur fyrir alla. Hver þátttakandi fær sinn eigin hlekk til að breyta svörunum.',
  step3: 'Sjáðu hvað hentar',
  step3Text: 'Dagarnir og tímarnir sem henta flestum koma efst.',
  loading: 'Hleður …',
  pageNotFound: 'Síðan fannst ekki',
  toHome: 'Á forsíðuna',
  eventNotFound: 'Viðburðurinn fannst ekki',
  eventNotFoundText: 'Honum gæti hafa verið eytt, eða hlekkurinn er rangur. Viðburðum er eytt sjálfkrafa 30 dögum eftir síðustu dagsetningu.',
  retry: 'Reyna aftur',
  reload: 'Endurhlaða',
  newVersion: 'Ný útgáfa er tilbúin.',
  changedMeanwhile: 'Einhver annar var að breyta viðburðinum.',
  back: 'Til baka',
  cancel: 'Hætta við',
  ok: 'Í lagi',
  done: 'Lokið',
  save: 'Vista',
  saved: 'Vistað',
  delete: 'Eyða',
  deleted: 'Eytt',
  copy: 'Afrita',
  copied: 'Afritað',
  share: 'Deila',
  link: 'Hlekkur',
  more: 'Meira',
  yes: 'Já',
  maybe: 'Kannski',
  no: 'Nei',
  name: 'Nafn',
  sum: 'Geta',
  you: 'þú',
  language: 'Tungumál',

  editEvent: 'Breyta viðburðinum',
  aboutEvent: 'Um viðburðinn',
  eventName: 'Heiti viðburðar',
  eventNamePh: 'Til dæmis „Jólahlaðborð“',
  descriptionOptional: 'Lýsing (valfrjálst)',
  locationOptional: 'Staður (valfrjálst)',
  whatToFind: 'Hvað viljið þið finna?',
  'mode.dates': 'Dagar',
  'mode.datesHint': 'Hvaða dagar henta?',
  'mode.times': 'Tímar',
  'mode.timesHint': 'Hvaða tímar henta, dag fyrir dag?',
  fromHour: 'Frá kl.',
  toHour: 'Til kl.',
  slotLength: 'Lengd reita',
  meetingLength: 'Lengd fundar',
  timeZone: 'Tímabelti',
  timeZoneHint: 'Allir sjá tímana í þessu tímabelti.',
  possibleDays: 'Mögulegir dagar',
  theme: 'Útlit',
  'theme.auto': 'Sjálfvirkt',
  'theme.autoHint': 'Ljóst eða dökkt, eins og tækið',
  'theme.light': 'Ljóst',
  'theme.dark': 'Dökkt',
  'theme.hacker': 'Hakkari',
  rangeHint: 'Dragðu frá einum degi að öðrum til að taka alla dagana á milli með, eða smelltu á þann fyrsta og shift-smelltu á þann síðasta.',
  rangeHintTouch: 'Haltu fingrinum á degi og dragðu að öðrum til að taka alla dagana á milli með.',
  possibleDaysHint: 'Ýttu á dagana sem gætu hentað, eða veldu fleiri með hnöppunum. Hnapparnir breyta aðeins valinu – þú getur samt bætt við eða fjarlægt staka daga á eftir.',
  period2w: 'Næstu 2 vikur',
  period4w: 'Næstu 4 vikur',
  periodMonth: 'Allan {month}',
  periodHint: 'Velur nákvæmlega þessa daga (í stað þeirra sem þú valdir)',
  moreMonths: 'Sýna næsta mánuð',
  selNone: 'Ekkert',
  undo: 'Afturkalla',
  redo: 'Endurgera',
  removedDays: { one: 'Fjarlægði {n} dag', other: 'Fjarlægði {n} daga' },
  timesCleared: 'Tímarnir voru fjarlægðir',
  weekdays: 'Virkir dagar',
  weekends: 'Helgar',
  holidays: 'Frídagar',
  weekdaysHint: 'Fjarlægðu valda virka daga (mánudag–föstudag), eða veldu þá alla í dagatalinu',
  weekendsHint: 'Fjarlægðu valda laugardaga og sunnudaga, eða veldu þá alla í dagatalinu',
  holidaysHint: 'Fjarlægðu valda frídaga, eða veldu alla frídagana í dagatalinu',
  weekdayHint: 'Fjarlægðu valda daga ({day}), eða veldu þá alla í dagatalinu',
  toggleWeek: 'Velja eða fjarlægja viku {n}',
  weekShort: 'V',
  nDays: { one: '{n} dagur valinn', other: '{n} dagar valdir' },
  nSlots: { one: '{n} tímareitur', other: '{n} tímareitir' },
  nDaysNoTimes: { one: '{n} dagur án tíma', other: '{n} dagar án tíma' },
  possibleTimes: 'Mögulegir tímar',
  possibleTimesHint: 'Dragðu yfir reitina til að merkja eða hreinsa tíma. Ýttu á dag efst fyrir fleiri valkosti.',
  possibleTimesHintTouch: 'Ýttu á reit til að merkja hann eða hreinsa, eða haltu fingrinum á reit og dragðu yfir fleiri. Ýttu á dag efst fyrir fleiri valkosti.',
  'preset.all': 'Allan daginn',
  'preset.work': 'Vinnutími 9–17',
  'preset.evening': 'Kvöld 17–22',
  'preset.clear': 'Engir tímar',
  pickDaysFirst: 'Veldu fyrst daga í dagatalinu.',
  dayAll: 'Velja allan daginn',
  dayClear: 'Hreinsa alla tíma þennan dag',
  dayCopy: 'Nota þessa tíma á alla daga',
  dayCopyHint: 'Dagar sem þú bætir við síðar fá líka þessa tíma',
  dayRemove: 'Fjarlægja daginn',
  settings: 'Stillingar',
  'set.maybe': 'Leyfa „kannski“',
  'set.maybeHint': 'Þátttakendur geta svarað „get ef þarf“.',
  'set.maybeCounts': '„Kannski“ telst sem að þeir geti',
  'set.maybeCountsHint': 'Röðunin telur alla sem geta eða geta kannski. Annars telst aðeins já, og ef já eru jafnmörg kemur sá með flest „kannski“ fyrst.',
  'set.openEdit': 'breytt og eytt svörum allra',
  'set.openEditHint': 'Annars aðeins sínu eigin.',
  'set.hidden': 'séð svörin',
  'set.hiddenHint': 'Hver svaraði hverju og hve margir. Annars sjá aðeins skipuleggjendurnir það og hver þátttakandi sitt eigið svar.',
  'set.closed': 'Lokað fyrir ný svör',
  'set.closedHint': 'Enginn nema skipuleggjendurnir getur svarað eða breytt neinu.',
  'set.newNames': 'svarað undir nýju nafni',
  'set.newNamesHint': 'Annars geta aðeins nöfnin sem þið settuð á listann svarað.',
  'set.claims': 'svarað sem nafn á listanum',
  'set.claimsHint': 'Með því að ýta á nafnið sitt með hlekknum á viðburðinn. Annars þurfa þeir persónulega hlekkinn sinn frá ykkur.',
  'set.rename': 'breytt nafninu sínu',
  'set.renameHint': 'Annars stendur nafnið eins og það var fyrst skrifað, eða eins og þið skrifuðuð það á listann.',
  'set.decide': 'valið hvað verður',
  'set.decideHint': 'Valið endanlegan dag eða tíma og afturkallað valið. Viðburðurinn er áfram opinn: aðeins skipuleggjendurnir loka honum.',
  'set.details': 'breytt heiti, stað og lýsingu',
  'set.detailsHint': 'Viðburðarins. Það sést ekki hver breytti þeim, en þið getið alltaf breytt þeim aftur.',
  yourEmailOptional: 'Netfangið þitt (valfrjálst)',
  adminEmailsOptional: 'Netföng skipuleggjenda (valfrjálst)',
  addDetails: 'Bæta við lýsingu og stað',
  manyWeeks: 'Þátttakendur þurfa að fara í gegnum {n} vikur af tímum, eina viku í einu í síma. Færri dagar gera það fljótlegra að svara.',
  emailOptional: 'Netfang (valfrjálst)',
  addEmail: 'Bæta við netfangi',
  adminEmailHint: 'Vistað með viðburðinum svo að þú getir fundið viðburðinn aftur á öðru tæki (við sendum þér kóða). Ef skipuleggjendur eru fleiri getur hver bætt við sínu netfangi. Aðeins þau sem eru með stjórnandahlekkinn sjá þau.',
  addEmailRow: 'Bæta við öðru netfangi',
  removeEmail: 'Fjarlægja netfangið',
  createEvent: 'Búa til viðburð',
  saveChanges: 'Vista breytingar',
  lostAnswers: {
    one: '{n} svar á við daga eða tíma sem eru fjarlægðir og verður eytt.',
    other: '{n} svör eiga við daga eða tíma sem eru fjarlægðir og verður eytt.',
  },
  saveAnyway: 'Vista samt',

  createdTitle: 'Viðburðurinn er tilbúinn!',
  createdText: 'Deildu hlekknum á viðburðinn með þeim sem þú vilt bjóða. Geymdu stjórnandahlekkinn: með honum breytirðu viðburðinum, og þú getur deilt honum með öðrum skipuleggjendum.',
  savedNewTitle: 'Takk, {name}! Svörin eru vistuð.',
  savedNewText: 'Þetta er þinn persónulegi hlekkur. Með honum geturðu breytt svörunum síðar, úr hvaða tæki sem er.',
  savedNewHint: 'Geymdu hlekkinn: vistaðu hann sem bókamerki eða sendu hann til þín. Ekki deila honum – sá sem hefur hlekkinn getur breytt svörunum þínum.',
  yourLink: 'Persónulegi hlekkurinn þinn',
  linkInvalid: 'Þessi hlekkur virkar ekki lengur. Honum gæti hafa verið skipt út fyrir nýjan, eða svarinu hefur verið eytt. Þú sérð viðburðinn sem gestur.',
  storedAdmin: 'Þú ert stjórnandi þessa viðburðar á þessu tæki.',
  storedMine: 'Þetta tæki er með persónulega hlekkinn þinn að þessum viðburði.',
  closedInfo: 'Lokað hefur verið fyrir ný svör.',
  closedAdmin: 'Lokað hefur verið fyrir ný svör. Aðeins skipuleggjendurnir geta bætt við eða breytt svörum.',
  metaDates: { one: '{n} mögulegur dagur', other: '{n} mögulegir dagar' },
  metaTimes: 'Tímar · fundurinn tekur {dur}',
  timesIn: 'Tímar í {tz}',
  yourTz: '(þú ert í {tz})',
  metaHidden: 'Aðeins skipuleggjendurnir sjá svörin',
  metaOpenEdit: 'Allir geta breytt svörunum',
  permsTitle: 'Þátttakendur geta',
  metaListOnly: 'Aðeins nöfnin á listanum geta svarað',
  metaDecide: 'Allir geta valið hvað verður',
  editDetails: 'Breyta heiti og stað',
  editDetailsHint: 'Allir með hlekkinn á viðburðinn sjá breytinguna.',
  detailsSaved: 'Breytingarnar eru vistaðar.',
  listOnlyInfo: 'Aðeins þeir sem eru á listanum geta svarað, með persónulega hlekknum sem þeir fengu frá skipuleggjendunum.',
  listOnlyClaim: 'Aðeins nöfnin á listanum geta svarað.',
  nameFixed: 'Ekki er hægt að breyta nafninu í þessum viðburði.',
  youAreAdmin: 'Þú ert stjórnandi',
  adminHint: 'Þú getur breytt viðburðinum og öllum svörunum.',
  addAnswers: 'Bæta við svörum',
  personName: 'Nafn',
  close: 'Loka',
  reopen: 'Opna aftur',
  hiName: 'Hæ, {name}!',
  personalHint: 'Þetta er þinn persónulegi hlekkur. Notaðu hann þegar þú vilt breyta svörunum.',
  editYourAnswers: 'Breyta svörunum þínum',
  copyMyLink: 'Afrita hlekkinn minn',
  shareEvent: 'Deila viðburðinum',
  addYourAnswers: 'Bæta við svörunum þínum',
  shareTitle: 'Deila viðburðinum',
  shareHint: 'Sendu þennan hlekk til allra sem eiga að vera með.',
  eventLink: 'Hlekkur á viðburðinn',
  adminLinkTitle: 'Stjórnandahlekkurinn',
  adminLinkHint: 'Deildu honum með þeim sem eiga að skipuleggja með þér. Allir sem hafa hann geta breytt viðburðinum og öllum svörunum.',
  qrTitle: 'QR-kóði fyrir viðburðinn',
  resultsTitle: 'Hvað hentar best?',
  noAnswersYet: 'Enginn hefur svarað enn.',
  noneAvailable: 'Enginn valkostanna hentar neinum enn.',
  hiddenInfo: 'Svörin eru falin: aðeins skipuleggjendurnir sjá þau og hve margir hafa svarað.',
  'tab.cal': 'Dagatal',
  'tab.list': 'Listi',
  'tab.table': 'Tafla',
  'tab.grid': 'Reitir',
  legendFew: 'Fáir geta',
  legendMany: 'Margir geta',
  legendTop: 'Flestir geta',
  tapForDetails: 'Ýttu á valkost til að sjá hverjir geta.',
  tapCellForDetails: 'Ýttu á reit til að sjá hverjir geta.',
  nOfM: '{n} af {m} geta',
  decidedTitle: 'Ákveðið',
  decidedTag: 'Valið',
  decidedThis: 'Þetta er valið',
  decideThis: 'Velja {when}',
  decideQ: 'Velja {when}? Allir sem opna viðburðinn sjá valið, og lokað verður fyrir ný svör.',
  decideOk: 'Velja',
  decidedToast: 'Valið. Deildu hlekknum, þá sjá allir það.',
  undecideQ: 'Afturkalla valið? Áfram verður lokað fyrir ný svör þar til þú opnar aftur.',
  decideQOpen: 'Velja {when}? Allir sem opna viðburðinn sjá valið.',
  undecideQOpen: 'Afturkalla valið?',
  undoDecision: 'Afturkalla valið',
  undecidedToast: 'Valið var afturkallað',
  addToCalendar: 'Setja í dagatal',
  nMaybe: { one: '{n} kannski', other: '{n} kannski' },
  nMaybeIncl: { one: 'þ.m.t. {n} kannski', other: 'þ.m.t. {n} kannski' },
  moreTied: { one: 'Sýna {n} í viðbót sem jafnmargir geta', other: 'Sýna {n} í viðbót sem jafnmargir geta' },
  showFewer: 'Sýna færri',
  rankYesFirst: 'Raðað eftir flestum já. Ef jafnt er kemur sá með flest „kannski“ fyrst.',
  rankMaybeCounts: 'Raðað eftir flestum sem geta, „kannski“ meðtalið. Ef jafnt er kemur sá með flest já fyrst.',
  canCome: 'Get',
  ifNeedBe: 'Kannski',
  cannot: 'Get ekki',
  responses: 'Svör',
  hiddenPeople: 'Svörin eru falin. Þú sérð aðeins þitt eigið.',
  sumYes: 'Getur {n} af {m}',
  sumYesTime: 'Getur {dur}',
  maybeDur: 'kannski {dur}',
  sumNoneDates: 'Getur engan daganna',
  sumNoneTimes: 'Getur engan tímanna',
  nOfTotal: '{n} af {m}',
  answeredOf: '{n} af {m} hafa svarað',
  notAnswered: 'Ekki svarað enn',
  noAnswer: 'Ósvarað',
  youNotAnswered: 'Þú hefur ekki svarað enn.',
  addNames: 'Bæta við nöfnum',
  addNamesTitle: 'Hverjum er boðið?',
  addNamesText: 'Eitt nafn í hverja línu, eða límdu inn lista. Þá sérðu hver eiga eftir að svara, og hvert nafn fær sinn eigin hlekk sem þú getur sent áfram. Öll sem opna viðburðinn sjá nöfnin, nema svörin séu falin.',
  addNamesPh: 'Anna\nJón\nSigga',
  addNamesOk: 'Bæta við',
  namesAdded: { one: 'Bætti við {n} nafni.', other: 'Bætti við {n} nöfnum.' },
  namesSkipped: { one: '{n} nafn var þegar á listanum.', other: '{n} nöfn voru þegar á listanum.' },
  copyReminder: 'Afrita áminningu',
  reminderText: '{names}: munið að svara „{name}“! {url}',
  claimQ: 'Ertu á listanum?',
  claimHint: 'Ýttu á nafnið þitt og svörin þín vistast þar. Ef þú ert ekki á listanum skrifarðu bara nafnið þitt.',
  claimWho: 'Hver ert þú?',
  claimListHint: 'Aðeins nöfnin á listanum geta svarað. Skrifaðu til að finna þitt.',
  claimAdmin: 'Svarar þú fyrir einhvern á listanum?',
  claimAdminHint: 'Ýttu á nafn til að setja svörin þar, eða skrifaðu nýtt nafn.',
  answerFor: 'Svara fyrir {name}',
  removeName: 'Fjarlægja {name}',
  removeNameQ: 'Fjarlægja {name} af listanum?',
  remove: 'Fjarlægja',
  showAnswered: 'Sýna sem svarað',
  draftNoteOwn: 'Vistað sem drög: þú ert undir „Ekki svarað enn“ og svörin eru ekki talin með fyrr en þú vistar með þetta valið.',
  draftNote: 'Vistað sem drög: viðkomandi er undir „Ekki svarað enn“ og svörin eru ekki talin með fyrr en vistað er með þetta valið.',
  draftSaved: 'Drögin eru vistuð. Þau eru ekki talin með fyrr en þau eru vistuð sem svarað.',
  savedDraftTitle: 'Drögin þín eru vistuð, {name}.',
  youHaveDraft: 'Þú átt drög sem eru ekki talin með enn.',
  claimNone: 'Enginn á listanum heitir þetta, svo þetta verður nýtt nafn.',
  claimMatches: { one: '{n} nafn á listanum passar', other: '{n} nöfn á listanum passa' },
  showAllNames: 'Sýna öll ({n})',
  answerAs: 'Svara sem {name}',
  copyPersonLink: 'Hlekkurinn fyrir {name}',
  deleteEntry: 'Eyða svarinu frá {name}',
  expiresNote: 'Viðburðinum verður eytt sjálfkrafa {date}.',
  adminMenu: 'Stjórnandi',
  newAdminLink: 'Nýr stjórnandahlekkur',
  newAdminLinkHint: 'Sá gamli hættir að virka',
  newAdminLinkQ: 'Búa til nýjan stjórnandahlekk? Sá gamli hættir strax að virka, hjá öllum sem hafa hann.',
  makeNewLink: 'Búa til nýjan hlekk',
  newLinkDone: 'Nýr hlekkur',
  newAdminLinkDoneText: 'Þetta er nýi stjórnandahlekkurinn. Sá gamli virkar ekki lengur, svo sendu þennan öðrum skipuleggjendum ef einhverjir eru.',
  deleteEvent: 'Eyða viðburðinum',
  deleteEventHint: 'Eyðir öllu, líka öllum svörunum',
  deleteEventQ: 'Eyða viðburðinum og öllum svörunum? Það er ekki hægt að afturkalla.',
  eventDeleted: 'Viðburðinum hefur verið eytt',
  meMenu: 'Svörin þín',
  newMyLink: 'Nýr persónulegur hlekkur',
  newMyLinkHint: 'Sá gamli hættir að virka',
  newMyLinkQ: 'Búa til nýjan persónulegan hlekk? Sá gamli hættir strax að virka.',
  newMyLinkDoneText: 'Þetta er nýi persónulegi hlekkurinn þinn. Sá gamli virkar ekki lengur.',
  deleteMine: 'Eyða svörunum mínum',
  deleteMineQ: 'Eyða svörunum þínum?',
  deleteEntryQ: 'Eyða svarinu frá {name}?',
  personLinkTitle: 'Hlekkurinn fyrir {name}',
  personLinkText: 'Sá sem hefur þennan hlekk getur breytt svörunum. Sendu hann aðeins til viðkomandi.',
  addedByAdminText: 'Svarinu var bætt við. Með þessum hlekk getur viðkomandi sjálfur breytt svörunum síðar.',
  closedToast: 'Lokað fyrir ný svör',
  reopenedToast: 'Opnað aftur fyrir svör',

  editAnswersOf: 'Breyta svörunum frá {name}',
  yourName: 'Nafnið þitt',
  emailHint: 'Vistað með svarinu svo að þú getir fundið viðburðinn aftur á öðru tæki (við sendum þér kóða). Enginn annar sér það.',
  commentOptional: 'Athugasemd (valfrjálst)',
  commentPh: 'Til dæmis „Get bara eftir kl. 18“',
  whichDays: 'Hvaða dagar henta?',
  whichTimes: 'Hvaða tímar henta?',
  answerDatesHint: 'Ýttu á dagana sem þú getur.',
  answerDatesHintMaybe: 'Ýttu einu sinni fyrir „já“, tvisvar fyrir „kannski“ og þrisvar til að fjarlægja.',
  answerTimesHint: 'Dragðu yfir tímana sem þú getur. Dragðu frá merktum reit til að fjarlægja. Ýttu á dag efst til að svara fyrir allan daginn.',
  answerTimesHintMaybe: 'Veldu „Get“ eða „Kannski“ og dragðu yfir tímana. Dragðu frá merktum reit til að fjarlægja. Ýttu á dag efst til að svara fyrir allan daginn.',
  answerTimesHintTouch: 'Ýttu á tímana sem þú getur, eða haltu fingrinum á reit og dragðu yfir fleiri. Byrjaðu á merktum reit til að fjarlægja. Ýttu á dag efst til að svara fyrir allan daginn.',
  answerTimesHintTouchMaybe: 'Veldu „Get“ eða „Kannski“ og ýttu á tímana, eða haltu fingrinum á reit og dragðu yfir fleiri. Byrjaðu á merktum reit til að fjarlægja. Ýttu á dag efst til að svara fyrir allan daginn.',
  brush: 'Merkja sem',
  yesToAll: 'Já við öllu',
  clearAll: 'Hreinsa',
  dayYes: 'Get allan daginn',
  dayMaybe: 'Kannski allan daginn',
  dayNone: 'Get ekki þennan dag',
  pickSumDates: 'Þú getur {n} af {m} dögum',
  pickSumTimes: 'Þú getur {dur}',
  pickSumNone: 'Ekkert merkt enn',
  discardQ: 'Henda breytingunum?',
  discard: 'Henda',

  weeks: 'Vikur',
  weekN: 'Vika {n}',
  weekRange: 'Vikur {a}–{b}',
  weekPair: 'Vikur {a} og {b}',
  gridPaintLabel: 'Tímar. Örvalyklarnir færa, bilslá merkir.',
  gridViewLabel: 'Yfirlit yfir tímana',

  'err.network': 'Náði ekki sambandi við netþjóninn. Athugaðu nettenginguna og reyndu aftur.',
  'err.rate': 'Of margar beiðnir. Bíddu aðeins og reyndu aftur.',
  'err.notFound': 'Viðburðurinn fannst ekki.',
  'err.forbidden': 'Þú hefur ekki leyfi til að gera þetta.',
  'err.listOnly': 'Aðeins nöfnin á listanum geta svarað. Veldu þitt.',
  'err.rename': 'Ekki er hægt að breyta nafninu í þessum viðburði.',
  'err.decided': 'Þetta er ekki einn af valkostunum.',
  'err.closed': 'Lokað hefur verið fyrir ný svör.',
  'err.full': 'Viðburðurinn hefur fengið eins mörg svör og hann rúmar.',
  'err.person': 'Svarið fannst ekki. Því gæti hafa verið eytt.',
  'err.personName': 'Skrifaðu nafnið þitt.',
  'err.email': 'Netfangið lítur ekki rétt út.',
  'err.emails': 'Mest 10 netföng.',
  'err.code': 'Kóðinn er rangur eða útrunninn.',
  'err.link': 'Hlekkurinn hefur þegar verið notaður eða er útrunninn. Biddu um nýjan kóða.',
  'err.wait.minute': 'Þú baðst rétt í þessu um kóða. Bíddu í mínútu áður en þú biður um nýjan.',
  'err.wait.hour': 'Þú hefur beðið um nokkra kóða. Reyndu aftur eftir klukkutíma.',
  'err.wait.day': 'Hámarki kóða fyrir daginn er náð. Reyndu aftur á morgun.',
  'err.mail': 'Við getum ekki sent tölvupóst eins og er. Reyndu aftur síðar.',
  'err.name': 'Gefðu viðburðinum heiti.',
  'err.range': 'Ógildar dagsetningar.',
  'err.rangeLong': 'Það má vera í mesta lagi eitt ár frá fyrsta til síðasta dags.',
  'err.rangeLongTimes': 'Með tímum má vera í mesta lagi 62 dagar frá fyrsta til síðasta dags.',
  'err.hours': 'Veldu gilt tímabil.',
  'err.options': 'Veldu að minnsta kosti einn mögulegan dag eða tíma.',
  'err.tooMany': 'Of margir mögulegir tímar (mest 2000). Veldu færri daga eða lengri reiti.',
  'err.server': 'Eitthvað fór úrskeiðis. Reyndu aftur.',
  'err.taken': 'Einhver var að svara undir þessu nafni. Veldu annað eða skrifaðu nafnið þitt.',
  'err.answered': 'Viðkomandi var að svara rétt í þessu, svo þau svör halda sér.',
  'err.names': 'Skrifaðu að minnsta kosti eitt nafn.',
  'err.tooManyNames': 'Þetta er of mikið. Viðburður getur haft í mesta lagi 200 nöfn og svör samanlagt.',

  'holiday.newYear': 'Nýársdagur',
  'holiday.maundyThursday': 'Skírdagur',
  'holiday.goodFriday': 'Föstudagurinn langi',
  'holiday.easter': 'Páskadagur',
  'holiday.easterMonday': 'Annar í páskum',
  'holiday.mayDay': 'Verkalýðsdagurinn',
  'holiday.constitutionDay': 'Þjóðhátíðardagur Noregs',
  'holiday.ascension': 'Uppstigningardagur',
  'holiday.whitsun': 'Hvítasunnudagur',
  'holiday.whitMonday': 'Annar í hvítasunnu',
  'holiday.christmas': 'Jóladagur',
  'holiday.boxingDay': 'Annar í jólum',
  'holiday.christmasEve': 'Aðfangadagur',
  'holiday.newYearsEve': 'Gamlársdagur',
  'holiday.epiphany': 'Þrettándinn',
  'holiday.nationalDaySe': 'Þjóðhátíðardagur Svíþjóðar',
  'holiday.midsummerEve': 'Miðsumarkvöld',
  'holiday.midsummerDay': 'Miðsumardagur',
  'holiday.allSaints': 'Allraheilagramessa',
  'holiday.greatPrayerDay': 'Kóngsbænadagur',
  holidayCal: 'Frídagar í dagatalinu',
  holidayCalHint: 'Frídagarnir fá punkt, og hnappurinn „Frídagar“ velur þá. Aðfangadagur og gamlársdagur eru með, í Svíþjóð líka miðsumarkvöld.',
  'holidayCal.no': 'Noregur',
  'holidayCal.se': 'Svíþjóð',
  'holidayCal.dk': 'Danmörk',
  'holidayCal.none': 'Engir',
};
